// extracted by mini-css-extract-plugin
export var choiceContainer = "styles-module--choice-container--NQZdK";
export var icon = "styles-module--icon--H4LmC";
export var questionSubtitle = "styles-module--question-subtitle--Y-X+T";
export var questionText = "styles-module--question-text--5eQgS";
export var tooltip = "styles-module--tooltip--V2Dct";
export var tooltipText = "styles-module--tooltip-text--1bfK8";